import TitleHeader from "@/components/TitleHeader";
import { useUserInfo } from "@/context/UserInfo";
import { formatAmount, parseAmount } from "@/utils/formatBalance";
import { Box, Flex, Input, Image, Text, useDisclosure } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import WithdrawAmountModal from "./WithdrawAmountModal";
import usePublicClient from "@/hooks/usePublicClient";
import { usdcInfo } from "@/constants/tokens";
import CapsuleLogoIcon from "./assets/capsule-logo.svg";
import { shortenAddress } from "@/utils";
import WithdrawButton from "./WithdrawButton";
import capsule from "@/constants/capsule";
import { encodeFunctionData } from "viem";
import { createBundler } from "@/constants/bundler";
import { useNavigate } from "react-router-dom";
import WithdrawLoading from "./WithdrawLoading";
import ErrorIcon from "./assets/error.png";
import { isAddress } from "viem";
import { createWithdrawOrder, Order, Status } from "@/api/order";
import WithdrawComplete from "./WithdrawComplete";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import Unverified from "./Unverified";
import UnverifiedTip from "./UnverifiedTip";
import { GoIcon } from "@/components/icons";
import NewBankModal from "./NewBankModal";
import NoBank from "./NoBank ";
import AddBank from "./AddBank";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";
import { ExternalAccount } from "@/api/bridge";
import BankCard from "./BankCard";

const SelectAccount = ({
  bankList,
  onWithdrawBank,
  onWithdrawWallet,
  handleSelectBank,
  handleCreateBank,
  bankErrorMessage,
  resetBankErrorMessage,
  isOpenNewBank,
  onCloseNewBank,
  onOpenNewBank,
}: {
  bankList: ExternalAccount[];
  onWithdrawBank: () => void;
  onWithdrawWallet: (address: string) => void;
  handleSelectBank: (bank: ExternalAccount) => void;
  handleCreateBank: (payload: any) => void;
  bankErrorMessage: string;
  resetBankErrorMessage: () => void;
  isOpenNewBank: boolean;
  onCloseNewBank: () => void;
  onOpenNewBank: () => void;
}) => {
  const { usdcBalance, smartAccount, address, senderAddress, bridgeCustomer } =
    useUserInfo();
  const { usdToCurrency, currencyUnit } = useCurrencyExchange();

  const kyced = bridgeCustomer?.status === "active";

  const navigate = useNavigate();
  const [otherWallet, setOtherWallet] = useState("");

  const handleCreateExternalAccount = () => {
    if (bridgeCustomer?.status === "active") {
      onOpenNewBank();
    } else if (bridgeCustomer?.id) {
      navigate("/verifyInfo");
    } else {
      navigate("/createKyc");
    }
  };

  const handleOpenAddBank = () => {
    onOpenNewBank();
  };

  const showAddressError = useMemo(() => {
    if (otherWallet === "") {
      return false;
    }
    return !isAddress(otherWallet);
  }, [otherWallet]);

  console.log(bankList, "kyced");

  return (
    <Flex sx={{ padding: "20px 0px 60px" }} flexDir={"column"} align={"center"}>
      <Box
        sx={{
          padding: "0 20px",
          width: "100%",
        }}
      >
        {" "}
        <TitleHeader
          color="#D8762B"
          title="Withdraw"
          onBack={() => {
            navigate("/myInfo");
          }}
          showSwitch={true}
        />
      </Box>

      <Box sx={{ marginTop: "20px" }}>
        <Text
          sx={{
            color: "#333",
            textAlign: "center",
            fontFamily: "DIN-Black",
            fontSize: "40px",
            fontWeight: 900,
          }}
        >
          {formatAmount(usdcBalance, usdcInfo.decimals)}{" "}
          <span
            style={{
              fontSize: "32px",
            }}
          >
            USDC
          </span>
        </Text>
        <Text
          sx={{
            textAlign: "center",
            color: "#333",
            fontFamily: "DIN",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 500,
          }}
        >
          {usdToCurrency(usdcBalance)} {currencyUnit}
        </Text>
      </Box>

      <Swiper
        slidesPerView={1.15}
        centeredSlides={true}
        spaceBetween={10}
        onSlideChange={(swiper) => {}}
        onSwiper={(swiper) => {}}
        style={{
          width: "100%",
          flex: 1,
          height: "170px",
          marginTop: "24px",
        }}
      >
        {!kyced && (
          <SwiperSlide style={{ height: "100%" }} key={0}>
            <Unverified></Unverified>
          </SwiperSlide>
        )}
        {kyced && bankList.length === 0 && (
          <SwiperSlide style={{ height: "100%" }} key={1}>
            <NoBank onClick={handleOpenAddBank}></NoBank>
          </SwiperSlide>
        )}
        {/* <SwiperSlide style={{ height: "100%" }} key={1}>
          <NoBank onClick={handleOpenAddBank}></NoBank>
        </SwiperSlide> */}
        {kyced &&
          bankList.length > 0 &&
          bankList.map((bank, index) => (
            <SwiperSlide style={{ height: "100%" }} key={bank.id}>
              <BankCard
                bank={bank}
                bankIndex={index + 1}
                onClick={() => handleSelectBank(bank)}
              ></BankCard>
            </SwiperSlide>
          ))}
        {kyced && bankList.length > 0 && (
          <SwiperSlide style={{ height: "100%" }} key={2}>
            <AddBank onAddAccountOpen={handleOpenAddBank}></AddBank>
          </SwiperSlide>
        )}
      </Swiper>

      <Box
        sx={{
          padding: "0 20px",
          width: "100%",
        }}
      >
        <Flex
          sx={{
            width: "100%",
            height: "60px",
            background: "#FFF",
            border: "1px solid #D8762B",
            filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.08))",
            borderRadius: "32px",
            marginTop: "20px",
            paddingLeft: "46px",
            overflow: "hidden",
          }}
          align={"center"}
        >
          <Image
            src={CapsuleLogoIcon}
            sx={{ width: "20px", marginRight: "30px" }}
          ></Image>
          <Box>
            <Text
              sx={{
                color: "#333",
                fontSize: "14px",
                fontWeight: 900,
              }}
            >
              Capsule
            </Text>
            <Text
              sx={{
                color: "#848484",
                fontSize: "14px",
                fontWeight: 500,
                marginTop: "2px",
              }}
            >
              {shortenAddress(address)}
            </Text>
          </Box>
          <Flex
            sx={{
              background: "#D8762B",
              width: "60px",
              height: "60px",
              marginLeft: "auto",
            }}
            align={"center"}
            justify={"center"}
            onClick={() => {
              onWithdrawWallet(address);
            }}
          >
            <GoIcon
              style={{
                width: "15px",
                color: "#fff",
              }}
            ></GoIcon>
          </Flex>
        </Flex>
        <Flex sx={{ width: "100%", marginTop: "20px" }} flexDir={"column"}>
          <Flex align={"center"}>
            <Text
              sx={{
                color: "#333",
                fontSize: "18px",
                fontWeight: 700,
                marginRight: "4px",
              }}
            >
              Other Wallets
            </Text>
            {showAddressError && (
              <Flex>
                <Image
                  src={ErrorIcon}
                  sx={{
                    width: "12px",
                    marginRight: "4px",
                  }}
                ></Image>
                <Text
                  sx={{
                    color: "#D60000",
                    fontSize: "12px",
                    fontWeight: 500,
                  }}
                >
                  Address Error
                </Text>
              </Flex>
            )}
          </Flex>
          <Flex
            sx={{
              width: "100%",
              height: "60px",
              background: "#FFF",
              border: "1px solid #D8762B",
              filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.08))",
              borderRadius: "32px",
              marginTop: "10px",
              paddingLeft: "26px",
              overflow: "hidden",
            }}
            align={"center"}
          >
            <Input
              variant={"unstyled"}
              sx={{
                width: "100%",
                background: "#FFF",
                flex: 1,
                fontSize: "12px",
                "&::placeholder": {
                  color: "#DEDEDE",
                },
              }}
              placeholder="Enter wallet address"
              value={otherWallet}
              onChange={(e) => setOtherWallet(e.target.value)}
            ></Input>
            <Flex
              sx={{
                background: "#D8762B",
                width: "60px",
                height: "60px",
                marginLeft: "auto",
              }}
              align={"center"}
              justify={"center"}
              onClick={() => {
                if (!isAddress(otherWallet)) {
                  return;
                }
                onWithdrawWallet(otherWallet);
              }}
            >
              <GoIcon
                style={{
                  width: "15px",
                  color: "#fff",
                }}
              ></GoIcon>
            </Flex>
          </Flex>
        </Flex>
      </Box>

      <UnverifiedTip></UnverifiedTip>
      <NewBankModal
        isOpen={isOpenNewBank}
        onClose={onCloseNewBank}
        onConfirm={handleCreateBank}
        errorMessage={bankErrorMessage}
        resetErrorMessage={resetBankErrorMessage}
      ></NewBankModal>
    </Flex>
  );
};

export default SelectAccount;
